<template>
  <div style="width:100%">
    <div
      class="h3 mb-2"
      style="font-family: Raleway; font-weight:bold; width: 1024px"
    >
      {{ title }}
    </div>
    <div class="row">
      <div class="col-2">
        <b>Course Number:</b>
      </div>
      <div class="data-field col-3">
        {{ courseName }}
      </div>
      <div class="text-right col-2">
        <b>Course Dates:</b>
      </div>
      <div
        class="data-field col-5"
      >
        {{ reportHeader.Dates }}
      </div>
    </div>
    <div class="row mb-3">
      <div class="col-2">
        <b>Host Council:</b>
      </div>
      <div class="data-field col-3">
        {{ reportHeader.HostingCouncil }}
      </div>
      <div class="text-right col-2">
        <b>Course Director:</b>
      </div>
      <div
        class="data-field col-5"
      >
        {{ reportHeader.CourseDirector }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ReportBudgetHeader',
  props: {
    reportHeader: {
      type: Object,
      default: function () {
        return {
          CourseKey: null,
          HostingCouncil: '',
          CourseDirector: '',
          Dates: '',
          Locations: ''
        }
      }
    },
    title: {
      type: String,
      default: ''
    }
  },
  computed: {
    courseName: function () {
      return this.$root.courseName
    }
  }
}
</script>
